module.exports = __webpack_public_path__ + "img/user-icon.ef54568e.png";